var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-circle": "stroke",
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "#1D1D46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M7.49935 10.2748C7.49935 10.551 7.72321 10.7748 7.99935 10.7748C8.27549 10.7748 8.49935 10.551 8.49935 10.2748H7.49935ZM8.73919 8.39157L8.47793 7.96525L8.47793 7.96525L8.73919 8.39157ZM9.20466 8.10632L9.46591 8.53264L9.46591 8.53264L9.20466 8.10632ZM5.16602 5.98517C5.16602 6.26131 5.38987 6.48517 5.66602 6.48517C5.94216 6.48517 6.16602 6.26131 6.16602 5.98517H5.16602ZM8.50865 12.0832C8.50865 11.8071 8.2848 11.5832 8.00865 11.5832C7.73251 11.5832 7.50865 11.8071 7.50865 12.0832H8.50865ZM7.50865 12.1564C7.50865 12.4325 7.73251 12.6564 8.00865 12.6564C8.2848 12.6564 8.50865 12.4325 8.50865 12.1564H7.50865ZM8.49935 10.2748V9.66229H7.49935V10.2748H8.49935ZM9.00044 8.81788L9.46591 8.53264L8.94341 7.68L8.47793 7.96525L9.00044 8.81788ZM10.8327 6.16886V5.98517H9.83268V6.16886H10.8327ZM7.99935 3.34033C6.47503 3.34033 5.16602 4.48565 5.16602 5.98517H6.16602C6.16602 5.11557 6.94634 4.34033 7.99935 4.34033V3.34033ZM10.8327 5.98517C10.8327 4.48565 9.52367 3.34033 7.99935 3.34033V4.34033C9.05236 4.34033 9.83268 5.11557 9.83268 5.98517H10.8327ZM9.46591 8.53264C10.3079 8.01666 10.8327 7.13398 10.8327 6.16886H9.83268C9.83268 6.76086 9.51087 7.33225 8.94341 7.68L9.46591 8.53264ZM8.49935 9.66229C8.49935 9.33822 8.67549 9.01702 9.00044 8.81788L8.47793 7.96525C7.87846 8.33261 7.49935 8.9651 7.49935 9.66229H8.49935ZM7.50865 12.0832V12.1564H8.50865V12.0832H7.50865Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSystem);
export default __webpack_public_path__ + "static/media/about-system.4ad8ede57e872976ca8346e528b08aef.svg";
export { ForwardRef as ReactComponent };